import { getCookie, setCookie } from 'tiny-cookie';

const gdpr = document.querySelector('[data-gdpr]');

function closeGdpr() {
    gdpr.classList.add('is-accepted');
    setCookie('gdpr-seen', 1, { expires: '30D' });
}

if (gdpr) {
    if (getCookie('gdpr-seen')) {
        gdpr.style.display = 'none';
    } else {
        const close = document.querySelector('[data-gdpr-close]');
        close.addEventListener('click', closeGdpr);
    }
}
